import React, { useEffect, useState } from 'react';
import { usePermissions } from '../contexts/permissionsContext';
import { useRouteChange } from '../contexts/routeChangeContextProvider';
import useAuth from '../hooks/useAuth';
import SimpleBackdrop from './loading/loading';

/**
 * @function RouteChangeLoading
 * @description Componente de loading para rota de mudança com atualização de permissões
 * @returns {JSX.Element} - Componente de loading
 */
const RouteChangeLoading = () => {
    const { isLoading, setIsLoading } = useRouteChange();
    const { clearCacheAndRefresh } = usePermissions();
    const { signed } = useAuth();
    const [isRefreshingPermissions, setIsRefreshingPermissions] = useState(false);

    useEffect(() => {
        if (isLoading && !isRefreshingPermissions) {
            // Só atualiza permissões se o usuário estiver autenticado
            if (!signed) {
                setIsLoading(false);
                return;
            }

            // Atualiza as permissões quando o loading é ativado (mudança de página)
            const refreshPermissions = async () => {
                try {
                    setIsRefreshingPermissions(true);
                    const result = await clearCacheAndRefresh();

                    if (result.success) {
                        // Aguarda um pouco para garantir que as permissões foram atualizadas
                        setTimeout(() => {
                            setIsRefreshingPermissions(false);
                            setIsLoading(false);
                        }, 300);
                    } else {
                        setIsRefreshingPermissions(false);
                        setIsLoading(false);
                    }
                } catch (error) {
                    console.error('Erro ao atualizar permissões:', error);
                    setIsRefreshingPermissions(false);
                    setIsLoading(false);
                }
            };

            refreshPermissions();
        }
    }, [isLoading, clearCacheAndRefresh, isRefreshingPermissions, setIsLoading, signed]);

    return (
        <SimpleBackdrop
            open={isLoading || isRefreshingPermissions}
            title="Carregando informações..."
        />
    );
};

export default RouteChangeLoading;
